import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import useAppContext from "../../../utils/Reducers";
import ButtonBar from "../../../components/Layout/ButtonBar";
import SearchBar from "./SearchBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalConfirm } from "../../../components/Confirm";
import { columnLayout } from "./columnLayout";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import {
  setStorageItem,
  getStorageItem,
} from "../../../hooks/Storage/useLocalStorage";
import moment from "moment";
import AUIGrid from "../../../lib/AuiGrid/AUIGridReact";
import { ModalDepartureImagePop } from "../../Popup/DepartureImagePop";
import {
  getGridValidateCheck,
  saveGridCheckData,
  isFieldDisabled,
} from "../../../utils/validators";
import { useInterval } from "../../../utils/validators";

//전송버튼을 클릭했을경우 함수가 외부에서 호출하여 primaryParameters 아무값도 들어가 있지 않음
//그래서 플래그를 두어 sendCnt값이 변경되면 useEffect에서 검색버튼의 함수를 실행시킴
var sendCnt = 0;

const InsepctionWaitMng = (props) => {
  var footerLayout = [
    {
      labelText: "합계",
      positionField: "#base",
    },
    {
      dataField: "inspno",
      positionField: "inspno",
      operation: "COUNT",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },

    {
      dataField: "inweight",
      positionField: "inweight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "outWeight",
      positionField: "outWeight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "outageWght",
      positionField: "outageWght",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "realWeight",
      positionField: "realWeight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
    {
      dataField: "totalweight",
      positionField: "totalweight",
      operation: "SUM",
      formatString: "#,##0",
      style: "aui-grid-my-header-sum-total",
    },
  ];
  const myGrid = useRef();
  const [research, setResearch] = useState(0);

  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.resize("100%", 600);
  }, [menuKey]);

  //console.log(userInfo);

  const [searchParameters, setSearchParameters] = useState({
    schPlantCd: userInfo.defaultPlantNo,
    schSearch: "",
    schTransStatusCd: "",
    schSwghtDt: moment().format("YYYY-MM-DD"),
    schEwghtDt: moment().format("YYYY-MM-DD"),
  });

  const initItem = {
    realWeight: "",
    statusD: "",
    statusI: "",
    statusS: "",
    statusT: "",
    statusTotal: "",
    statusW: "",
  };

  const [fieldValues, setFieldValues] = useState(initItem);

  const SEARCH_INSPECTIONWAITLIST_URL =
    "/domesticscrap/inspectionwait/searchInspectionWaitList.do";

  const SAVE_INSPECTION_PROGRESS_URL =
    "/inspection/video/saveInspectionProgress.do";

  const SAVE_INSPECTION_REAMARK_URL =
    "/domesticscrap/inspectionwait/saveInspectionRemark.do";

  //배차정보 저장 URL
  const CHANGE_TRANSO_STATUS_URL =
    "/domesticscrap/inspectionwait/changeTransStatus.do";

  //배차정보 저장 URL
  //const MESSAGE_TRANSORDER_URL = "http://tms.idaehan.com:8080/message/sendTransCallInMessage.do";
  const MESSAGE_TRANSORDER_URL =
    "https://tms.idaehan.com:8443/message/sendTransCallInMessage.do";

  //오늘 하루 통합 운송량 검색 URL
  const SERARCH_TRANSTOTALCOUNT_URL =
    "/domesticscrap/inspectionwait/searchTransTotalCount.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_INSPECTIONWAITLIST_URL,
    },
    { manual: true }
  );

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    if (research !== 0) {
      handleMasterSearch();
    }
  }, [research]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    const auiGrid = myGrid.current;
    auiGrid.setFooter(footerLayout);
    //Local Storage에 저장된 그리드 컬럼 정렬정보를 가져옴
    const columnList = getStorageItem(props.menuInfo.menuId, "");
    if (columnList !== "") {
      auiGrid.setColumnOrder(columnList);
    }
    const columnSize = getStorageItem(props.menuInfo.menuId + "_s", "");
    if (columnSize !== "") {
      //Local Storage에 저장된 그리드 컬럼 Width 정보를 가져옴
      auiGrid.setColumnSizeList(columnSize);
    }
    await handleMasterSearch();
  }, []);

  useInterval(() => {
    searchTransTotalCount();
  }, 60000);

  const searchTransTotalCount = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_TRANSTOTALCOUNT_URL,
      params: searchParameters,
    });

    //console.log(data);

    setFieldValues(data[0]);
  };

  const popDepartureImage = (event) => {
    //console.log(event.item);
    ModalDepartureImagePop({ tmsOdrNo: event.item.tmsOdrNo, type: "image" });
  };

  //그리드 정렬 저장
  const handleGridSorting = useCallback(() => {
    const auiGrid = myGrid.current;
    const items = auiGrid.getColumnInfoList();
    let columnList = [];
    let columnSize = [];
    items.forEach((item) => {
      columnList.push(item.dataField);
      columnSize.push(item.width);
    });
    setStorageItem(props.menuInfo.menuId, columnList);
    setStorageItem(props.menuInfo.menuId + "_s", columnSize);
    ModalConfirm({
      title: "그리드 정렬 저장",
      description: "그리드 정렬을 저장하였습니다. ",
    });
  });

  const handleMasterExcel = useCallback(() => {
    const auiGrid = myGrid.current;
    auiGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 리스트",
      exceptColumnFields: auiGrid.getHiddenColumnDataFields(),
    });
  });

  const handleMasterSearch = async () => {
    const auiGrid = myGrid.current;
    auiGrid.showAjaxLoader();
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_INSPECTIONWAITLIST_URL,
      params: searchParameters,
    });
    auiGrid.setGridData(data);
    auiGrid.removeAjaxLoader();
    await searchTransTotalCount();
  };

  const handleMasterSave = async () => {
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      let validator = [];

      const auiGrid = myGrid.current;
      var items = auiGrid.getGridData();

      const addItems = auiGrid.getAddedRowItems();
      const editItems = auiGrid.getEditedRowItems();
      const removeItems = auiGrid.getRemovedItems();
      let param = saveGridCheckData(addItems, editItems, removeItems);

      if (param.length > 0) {
        //console.log(param[0]);

        const {
          data: { data },
        } = await fetchData({
          url: SAVE_INSPECTION_REAMARK_URL,
          data: param,
          method: "POST",
        });
        handleMasterSearch();
      } else {
        ModalConfirm({
          title: "필수항목체크",
          description: "저장할 항목이 없습니다. ",
          type: "alert",
        });
      }
    }
  };

  //그리드 정렬 취소
  const handleGridSortingCancel = useCallback(() => {
    const auiGrid = myGrid.current;
    setStorageItem(props.menuInfo.menuId, "");
    var colLayout = columnLayout(popDepartureImage);
    auiGrid.changeColumnLayout(colLayout);
    ModalConfirm({
      title: "그리드 정렬 취소",
      description: "그리드 정렬을 취소하였습니다. ",
    });
  });

  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterSave={handleMasterSave}
        handleMasterExcel={handleMasterExcel}
        isGridSort={true}
        handleGridSorting={handleGridSorting}
        handleGridSortingCancel={handleGridSortingCancel}
      />
      <SearchBar
        setSearchParameters={setSearchParameters}
        searchParameters={searchParameters}
      />

      <table className="t_garo">
        <tr>
          <td> 운송차량 전체({fieldValues.statusTotal}대)</td>
          <td>1. 입고차량({fieldValues.statusS}대)</td>
          <td>2. 입고중량({fieldValues.realWeight}kg)</td>
          <td>3. 검수대기({fieldValues.statusW}대)</td>
          <td>4. 출차대기({fieldValues.statusI}대)</td>
          <td>5. 운송중({fieldValues.statusD}대)</td>
          <td>6. 운송대기({fieldValues.statusT}대)</td>
        </tr>
      </table>

      <AUIGrid
        ref={myGrid}
        columnLayout={columnLayout(popDepartureImage)}
        gridProps={{
          ...defaultGridProps,
          width: "100%",
          height: 600,
          editable: true,
          showFooter: true,
          footerPosition: "top",
        }}
      />
    </>
  );
};

export default InsepctionWaitMng;
